// import enquire from 'enquire.js/dist/enquire.min';

/* TODO: possible better solution for the autofill issue with other fields than the one you are in https://medium.com/@brunn/detecting-autofilled-fields-in-javascript-aed598d25da7 */

// Gravity Forms floating labels
// TODO: make select label float
function initFloatingLabels() {
    var floatingLabels = document.querySelectorAll('.c-form__item');

    function floatLabel(e) {
        var inputField = e.target;
        var parent = inputField.parentElement.offsetParent;

        // get different parent element for Gravity Forms password fields to make the floating label work
        if (inputField.parentElement.parentElement.classList.contains('ginput_container_password')) {
            parent = inputField.parentElement;
        }

        parent.classList.add('c-form__item--floating-label');
    }

    for (var i = 0, fLen = floatingLabels.length; i < fLen; i++) {
        var element = floatingLabels[i].querySelector('input, textarea');

        if (!element) return; // if input cannot be found, skip this label

        // on focus of any form input add 'c-form__item--floating-label' class it's li parent, to make the label float
        element.addEventListener('focus', function (e) {
            // console.log('focus');
            floatLabel(e);
        });

        // on lost focus (aka focusout) check if the input field is empty. If it isn't, keep the label floating
        element.addEventListener('blur', function (e) {
            var inputValue = e.target.value;
            var parent = e.target.parentElement.offsetParent;
            if (inputValue === '' || inputValue === undefined) {
                parent.classList.remove('c-form__item--floating-label');
            } else {
                parent.classList.add('c-form__item--floating-label');
            }
        });
    }

    // check if any of input fields has a value. If it does, add a 'c-form__item--floating-label' class to its li parent, to make the label float
    var inputs = document.querySelectorAll('.ginput_container > input, .ginput_container > textarea, .ginput_container_password input');

    for (var j = 0, len = inputs.length; j < len; j++) {
        var inputValue = inputs[j].value;
        var inputParent = inputs[j].parentElement.parentElement;
        if (inputValue) {
            inputParent.classList.add('c-form__item--floating-label');
        }
    }
}

/**
 * Add custom select dropdown
 */
function addCustomSelectDropdown() {
    var x, i, j, selElmnt, a, b, c;
    /* Look for any elements with the class "ginput_container_select": */
    x = document.querySelectorAll('.ginput_container_select, .gfield_date_dropdown_day, .gfield_date_dropdown_month, .gfield_date_dropdown_year');
    for (i = 0; i < x.length; i++) {
        selElmnt = x[i].getElementsByTagName('select')[0];
        /* For each element, create a new DIV that will act as the selected item: */
        a = document.createElement('DIV');
        a.setAttribute('class', 'select__selected');
        a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
        x[i].appendChild(a);
        /* For each element, create a new DIV that will contain the option list: */
        b = document.createElement('DIV');
        b.setAttribute('class', 'select__items select__items--hidden');
        // NOTE: when j = 0 the place holder is in the dropdown,
        // when j = 1 the first select option does not appear in the dropdown
        for (j = 0; j < selElmnt.length; j++) {
            /* For each option in the original select element,
            create a new DIV that will act as an option item: */
            c = document.createElement('DIV');
            c.innerHTML = selElmnt.options[j].innerHTML;
            c.addEventListener('click', function () {
                /* When an item is clicked, update the original select box,
                and the selected item: */
                var y, i, k, s, h;
                s = this.parentNode.parentNode.getElementsByTagName('select')[0];
                h = this.parentNode.previousSibling;
                for (i = 0; i < s.length; i++) {
                    if (s.options[i].innerHTML == this.innerHTML) {
                        s.selectedIndex = i;
                        h.innerHTML = this.innerHTML;
                        y = this.parentNode.getElementsByClassName('same-as-selected');
                        for (k = 0; k < y.length; k++) {
                            y[k].removeAttribute('class');
                        }
                        this.setAttribute('class', 'same-as-selected');
                        break;
                    }
                }
                h.click();
                $(s)[0].dispatchEvent(new Event('change')); // Trigger change event, so other depended listeners will fire as well.
            });
            b.appendChild(c);
        }
        x[i].appendChild(b);
        a.addEventListener('click', function (e) {
            /* When the select box is clicked, close any other select boxes,
            and open/close the current select box: */
            e.stopPropagation();
            closeAllSelect(this);
            this.nextSibling.classList.toggle('select__items--hidden');
            this.classList.toggle('select__arrow--active');
        });
    }
}

/* Select field dropdown
 * A function that will close all select boxes in the document,
 * except the current select box:
 */
function closeAllSelect(e) {
    var x,
        y,
        i,
        arrNo = [];
    x = document.getElementsByClassName('select__items');
    y = document.getElementsByClassName('select__selected');

    for (i = 0; i < y.length; i++) {
        if (e == y[i]) {
            arrNo.push(i);
        } else {
            y[i].classList.remove('select__arrow--active');
        }
    }
    for (i = 0; i < x.length; i++) {
        if (arrNo.indexOf(i)) {
            x[i].classList.add('select__items--hidden');
        }
    }
}

// FormValidation.io - Real time form validation
// TODO validation of date/select etc
// TODO Server side validation gravity forms. Not sure if that still works. Can be some simple fallback, normal user will not see this.
/* eslint-disable */
function formValidationCode() {
    // get the form by their .gform_body class
    const forms = document.querySelectorAll('form'),
        documentLanguage = document.documentElement.lang;

    // default error messages
    // use maximum of 39 characters to prevent the message from breaking into two lines
    let msgRequired = 'Required field',
        msgEmail = 'Not valid email address',
        msgConfirmPassword = 'The password and its confirm are not the same',
        msgWeakPassword = 'The password is weak'; // The default error message which will be shown to let user know that the password is weak. It then will be replaced with the warning message of zxcvbn library to indicate the specific reason why the password is weak

    // overwrite default messages with the language specific version
    if ('nl-NL' === documentLanguage) {
        // Dutch error messages
        // use maximum of 39 characters to prevent the message from breaking into two lines
        msgRequired = 'Verplicht veld';
        msgEmail = 'Geen geldig e-mailadres';
        msgConfirmPassword = 'Het wachtwoord en de bevestiging zijn niet hetzelfde';
        msgWeakPassword = 'Het wachtwoord is zwak'; // The default error message which will be shown to let user know that the password is weak. It then will be replaced with the warning message of zxcvbn library to indicate the specific reason why the password is weak
    }

    // console.log(forms);
    const addValidatorToForm = function (form) {
        return FormValidation.formValidation(form, {
            // validate these fields
            fields: {
                required: {
                    // css path to the input field
                    selector: '.gfield_contains_required .ginput_container:not(.ginput_container_checkbox):not(.ginput_container_radio) input:not([type=hidden]), .gfield_contains_required textarea',
                    validators: {
                        notEmpty: {
                            message: msgRequired,
                        },
                    },
                },
                // needed to show a green check mark on not required fields
                notRequired: {
                    // css path to the input field
                    selector: '.gfield:not(.gfield_contains_required) .ginput_container:not(.ginput_container_checkbox):not(.ginput_container_radio) input, .gfield:not(.gfield_contains_required) textarea',
                    validators: {},
                },
                // whenever you add custom validation for a input field you need to add validation for a normal and required option, see email and emailRequired filed
                email: {
                    // css path to the input field
                    selector: '.gfield:not(.gfield_contains_required) .ginput_container_email input',
                    validators: {
                        emailAddress: {
                            message: msgEmail,
                        },
                    },
                },
                emailRequired: {
                    // css path to the input field
                    selector: '.gfield.gfield_contains_required .ginput_container_email input',
                    validators: {
                        emailAddress: {
                            message: msgEmail,
                        },
                        notEmpty: {
                            message: msgRequired,
                        },
                    },
                },
                // XXX: validation of checkbox inputs fields need to be done separately from the above 'required' field, otherwise it causes errors
                checkbox: {
                    selector: '.gfield:not(.gfield_contains_required) .gfield_checkbox input',
                    validators: {},
                },
                checkboxRequired: {
                    selector: '.gfield.gfield_contains_required .gfield_checkbox input',
                    validators: {
                        notEmpty: {
                            message: msgRequired,
                        },
                    },
                },
                // XXX: validation of radio inputs fields need to be done separately from the above 'required' and 'notRequired' field, otherwise it causes errors
                radio: {
                    selector: '.gfield:not(.gfield_contains_required) .gfield_radio input',
                    validators: {},
                },
                radioRequired: {
                    selector: '.gfield.gfield_contains_required .gfield_radio input',
                    validators: {
                        notEmpty: {
                            message: msgRequired,
                        },
                    },
                },
                select: {
                    selector: '.gfield:not(.gfield_contains_required) .gfield_select',
                    validators: {},
                },
                selectRequired: {
                    selector: '.gfield.gfield_contains_required .gfield_select',
                    validators: {
                        notEmpty: {
                            message: msgRequired,
                        },
                    },
                },
                // create a password field to track for passwordStrength plugin
                password: {
                    selector: '.ginput_container_password > span:nth-child(1) input', // Gravity Forms password field
                    validators: {
                        notEmpty: {
                            message: msgRequired,
                        },
                    },
                },
                confirmPassword: {
                    selector: '.ginput_container_password > span:nth-child(2) input', // Gravity Forms password confirmation field
                    validators: {
                        notEmpty: {
                            message: msgRequired,
                        },
                        identical: {
                            compare: function () {
                                return form.querySelector('.ginput_container_password > span:nth-child(1) input').value;
                            },
                            message: msgConfirmPassword,
                        },
                    },
                },
            },
            // use these FormValidation features
            plugins: {
                // show error message in the tooltip
                tooltip: new FormValidation.plugins.Tooltip({
                    placement: 'top',
                    trigger: 'click',
                }),
                // upon validation add one of the following classes to the <i> element in the same container as the input field
                icon: new FormValidation.plugins.Icon({
                    valid: 'fv-plugins-icon--valid',
                    invalid: 'fv-plugins-icon--invalid',
                    validating: 'fv-plugins-icon--validating',
                }),
                // add error messages to the HTML
                message: new FormValidation.plugins.Message(),
                // trigger filed validation when something happens
                trigger: new FormValidation.plugins.Trigger({
                    // validate an input when a user exits the field
                    event: 'blur change',
                }),
                // Automatically validate the form when pressing its Submit button
                submitButton: new FormValidation.plugins.SubmitButton(),
                // Submit the form if all fields are valid after validating
                defaultSubmit: new FormValidation.plugins.DefaultSubmit(),
                passwordStrength: new FormValidation.plugins.PasswordStrength({
                    field: 'password',
                    message: msgWeakPassword,
                    minimalScore: 3,
                }),
            },
            // perform action when an input field is validated
        }).on('core.element.validated', function (e) {
            if (true === e.valid) {
                $(e.element).removeClass('invalid').addClass('valid');
            } else {
                $(e.element).removeClass('valid').addClass('invalid');
            }
        });
    };

    forms.forEach((form) => {
        addValidatorToForm(form);
    });
}
/* eslint-enable */

/**
 * Move tooltip icons to the beginning of the input wrapper
 * It fixes the issue that the FormValidation tooltip icons break radio and checkbox inputs
 */
function moveTootipIcons() {
    // get all tooltip icons tags on the page
    const tooltipIcons = document.querySelectorAll('.fv-plugins-icon');
    let i;

    //console.log('tooltipIcons:', tooltipIcons);

    // move each icon tag to the beginning of its parent
    for (i = 0; i < tooltipIcons.length; i++) {
        let iconElement = tooltipIcons[i];
        let iconParent = tooltipIcons[i].parentNode;
        // NOTE: IE11 fix - use insertBefore() instead of prepend(), because it works in all browsers
        iconParent.insertBefore(iconElement, iconParent.childNodes[0]);
    }
}

/**
 * Add a custom class to elements parent
 */
function addClassToElementsParent(elementsSelector, parentNewClass) {
    const textAreas = document.querySelectorAll(elementsSelector);

    for (let i = 0, max = textAreas.length; i < max; i++) {
        const parent = textAreas[i].parentElement;

        parent.classList.add(parentNewClass);
    }
}

/**
 * Load only if the page contains .gform_body,
 * which is the Gravity Form wrapper
 */
if (document.getElementsByClassName('gform_body').length) {
    var firstTimeLoad = true;

    // Execute when the Gravity Form is submitted
    $(document).bind('gform_post_render', function () {
        // execute code only if there is no custom select dropdown already
        if (!$('.select__items').length) {
            addCustomSelectDropdown();
        }

        initFloatingLabels();

        if (firstTimeLoad) {
            firstTimeLoad = false;
        } else {
            return;
        }

        formValidationCode();
    });

    // Add custom class to the textarea, checkbox and ratio parent
    addClassToElementsParent('.ginput_container_textarea', 'textarea-parent');
    addClassToElementsParent('.ginput_container_checkbox', 'checkbox');
    addClassToElementsParent('.ginput_container_radio', 'radio');

    // Gravity Forms floating labels
    initFloatingLabels();

    // Add custom select dropdown
    addCustomSelectDropdown();

    /* If the user clicks anywhere outside the select box,
    then close all select boxes: */
    document.addEventListener('click', closeAllSelect);

    // 7-1-2021 Martin Kilarski: we have browser specific loading behavior, because:
    // - $(document).ready() runs code too early in Chrome
    // - $(window).load() causes issues in Firefox
    if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
        $(window).ready(function () {
            moveTootipIcons();
        });
    } else {
        $(window).load(function () {
            moveTootipIcons();
        });
    }
}

/* Gravity Forms User Registration */
/* If form field has class disabled, apply disabled attribute to the input */
function makeDisabled(item) {
    if (item) {
        const fieldShouldBeDisabledInput = item.querySelector('input');
        if (fieldShouldBeDisabledInput) {
            fieldShouldBeDisabledInput.setAttribute('disabled', true);
        }
    }
}
if (document.querySelector('.gform_body')) {
    const fieldsShouldBeDisabled = document.querySelectorAll('.disabled');
    fieldsShouldBeDisabled.forEach(makeDisabled);
}



// WEBPACK FOOTER //
// ./scripts/routes/components/form.js